import { DeviceMobile, GearSix } from "@phosphor-icons/react"
import { AvatarTooltip } from "@/components/avatar-tooltip"
import { Badge } from "@/components/ui/badge"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { UserData } from "@/lib/fetch-users"
import { cn } from "@/lib/utils"

export const PATIENT_AVATAR_NAME = "Patient"
const SYSTEM_AVATAR_NAME = "System"
const SOFIA_CLI_AVATAR_NAME = "SofiaCli"
const SYSTEM_AVATAR_NAMES = [SYSTEM_AVATAR_NAME, SOFIA_CLI_AVATAR_NAME]

type UserAvatarTooltipProps = {
  user: UserData
  uniqueIdentifier: string
  size?: "xs" | "md"
}

const AvatarIcon = ({ className, children }: React.HTMLAttributes<HTMLDivElement>) => (
  <Badge className={cn("text-on-surface-subdued h-6 w-6 p-1", className)}>{children}</Badge>
)

const AvatarIconTooltip = ({ userName }: { userName: string }) => {
  return (
    <TooltipCustom>
      <TooltipTrigger>
        <AvatarIcon className={SYSTEM_AVATAR_NAMES.includes(userName) ? "bg-surface-subdued" : "bg-ochre-surface"}>
          {SYSTEM_AVATAR_NAMES.includes(userName) ? <GearSix size={18} /> : <DeviceMobile size={18} />}
        </AvatarIcon>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="bottom" align="start">
          <span className="p-1">{userName}</span>
        </TooltipContent>
      </TooltipPortal>
    </TooltipCustom>
  )
}
const UserAvatarTooltip = (props: UserAvatarTooltipProps) => {
  const { user, uniqueIdentifier, size } = props

  if (SYSTEM_AVATAR_NAMES.includes(user.userName) || user.userName === PATIENT_AVATAR_NAME) {
    return <AvatarIconTooltip userName={user.userName} />
  }

  return (
    <AvatarTooltip
      firstName={user.firstName}
      lastName={user.lastName}
      role={user.role}
      uniqueIdentifier={uniqueIdentifier}
      size={size}
      professionalTitle={user.professionalTitle}
    />
  )
}

export { UserAvatarTooltip }
